export enum BannerUpsellColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum BannerUpsellPicturePosition {
  START = 'start',
  END = 'end',
}

export enum BannerUpsellSize {
  SMALL = 'small',
  SMALL_WITH_IMAGE = 'small-with-image',
  LARGE = 'large',
  LARGE_WITH_IMAGE = 'large-with-image',
  XLARGE = 'xlarge',
}
